import { ReactElement, useEffect } from 'react';

import { STORAGE_KEY_AUTH_TOKEN } from '@localstack/constants';

// Intentionally narrow — only v2.app may request a token via the relay.
// Using the broader isOriginAllowed() would accept any *.localstack.cloud subdomain,
// giving any XSS on those subdomains a ready-made token theft path.
const RELAY_ORIGIN = 'https://v2.app.localstack.cloud';

export const AuthRelay = (): ReactElement => {
  useEffect(() => {
    if (!window.opener) return;

    const handleRequest = (event: MessageEvent) => {
      if (event.source !== window.opener) return;
      if (event.origin !== RELAY_ORIGIN) return;
      if (event.data?.type !== 'request-token') return;

      let token = '';
      try {
        token = JSON.parse(localStorage.getItem(STORAGE_KEY_AUTH_TOKEN) as string)?.metadata?.AccessToken ?? '';
      } catch {
        // token absent or unparseable — proceed with empty token
      }

      (event.source as Window).postMessage({ type: 'auth-token', token }, event.origin);
      window.close();
    };

    window.addEventListener('message', handleRequest);
    return () => window.removeEventListener('message', handleRequest);
  }, []);

  return <></>;
};
